/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CycleResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { CycleListDTO, RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class CycleResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addorUpdateCycle(cycleListDTO: CycleListDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    addorUpdateCycle(cycleListDTO: CycleListDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    addorUpdateCycle(cycleListDTO: CycleListDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    addorUpdateCycle(cycleListDTO: CycleListDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addorUpdateCycle`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: cycleListDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle1(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle1(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle1(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle2(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle2(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle2(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle2(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle4(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle4(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle4(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle4(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle3(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle3(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle3(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle3(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle6(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle6(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle6(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle6(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycle5(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<CycleListDTO>>;
    getCycle5(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<CycleListDTO>>>;
    getCycle5(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<CycleListDTO>>>;
    getCycle5(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-cycles`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById1(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById1(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById1(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById1(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById2(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById2(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById2(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById2(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById4(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById4(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById4(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById4(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById3(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById3(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById3(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById3(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById6(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById6(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById6(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById6(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCycleById5(idCycle?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<CycleListDTO>;
    getCycleById5(idCycle?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<CycleListDTO>>;
    getCycleById5(idCycle?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<CycleListDTO>>;
    getCycleById5(idCycle?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cycle`;

        let params = new HttpParams();
        if (idCycle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idCycle, 'idCycle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
